import { Routes } from '@angular/router';
import { adminGuard } from '@tsin-core/guards/admin.guard';
import { authGuard } from '@tsin-core/guards/auth.guard';

export const routes: Routes = [
    // { path: '', redirectTo: '/account/validate-login', pathMatch: 'full' },
    { path: '', redirectTo: '/user', pathMatch: 'full' },
    {
        path: 'user',
        canActivate: [authGuard],
        loadChildren: () => import('./pages/user/user.routes')
    },
    {
        path: 'management',
        canActivate: [adminGuard],
        data: { preload: true },
        loadChildren: () => import('./pages/management/management.routes')
    },
    {
        path: 'account',
        data: { preload: true },
        loadChildren: () => import('./pages/account/account.routes')
    },
    {
        path: 'careers',
        data: { preload: true },
        loadChildren: () => import('./pages/careers/career.routes')
    },
    {
        path: 'managers',
        canActivate: [adminGuard],
        data: { preload: true },
        loadChildren: () => import('./pages/managers/managers.routes')
    },
    {
        path: 'employee',
        // canActivate: [adminGuard],
        data: { preload: true },
        loadChildren: () => import('./pages/employee/employee.routes')
    },
    {
        path: 'IT',
        canActivate: [adminGuard],
        data: { preload: true },
        loadChildren: () => import('./pages/it-management/it.routes')
    },
    {
        path: 'finance',
        canActivate: [adminGuard],

        data: { preload: true },
        loadChildren: () => import('./pages/finance/finance.routes')
    },
    { path: '**', redirectTo: 'user' }
];
